'use client';

import { useRouter } from 'next/navigation';
import { Button, Group, Text, Title } from '@mantine/core';
import { useTranslation } from '@/i18n/client';
import { Illustration } from './Illustration';
import classes from './NothingFoundBackground.module.css';

export function NothingFoundBackground() {
  const { push } = useRouter();
  const { t } = useTranslation('404');
  return (
    <div className={classes.wrapper}>
      <div className={classes.inner}>
        <Illustration className={classes.image} />
        <div className={classes.content}>
          <Title className={classes.title}>{t('title')}</Title>
          <Text size='lg' ta='center' className={classes.description}>
            {t('description')}
          </Text>
          <Group justify='center'>
            <Button
              size='lg'
              variant='outline'
              className={classes.button}
              onClick={() => push('/')}
            >
              {t('button')}
            </Button>
          </Group>
        </div>
      </div>
    </div>
  );
}
